import { mapActions, mapGetters } from 'vuex'
import UsesAuth0 from '@/mixins/UsesAuth0'
import UsesNotifications from '@/mixins/UsesNotifications'

/**
 * This mixin requires that the parent component mount the Stripe client if card payments are expected.
 */
export default {
  mixins: [UsesAuth0, UsesNotifications],
  data: () => ({
    creatingNewSubscription: true
  }),
  computed: {
    ...mapGetters({
      activeSubscription: 'user/getActiveSubscription'
    })
  },
  created() {
    this.getActiveSubscription(false).then(() => {
      if (Object.keys(this.activeSubscription).length > 0) {
        this.creatingNewSubscription = false
      }
    })
  },
  methods: {
    ...mapActions({
      initUserMetaData: 'user/initAuthUser',
      getActiveSubscription: 'user/getActiveSubscription'
    }),
    /**
     * @param plan
     * {
     *   title: String,
     *   price: Number,
     *   code: String,
     *   requiresContact: Boolean
     * }
     * @param creatingNewSubscription Boolean indicates if this is a new subscription or updating a current subscription
     * @returns {Promise<void>}
     */
    async updateSubscription(plan) {
      if (plan.price !== '0.00') {
        if (this.cards.length === 0) {
          this.$v.$touch()
        } else {
          this.$v.$reset()
        }

        if (this.$v.$error) {
          return
        }
      }

      this.loading = true

      if (plan.price !== '0.00') {
        if (this.cards.length === 0) {
          try {
            await this.addCard()
          } catch (e) {
            this.showError(e.message)
            this.loading = false
            return
          }
        }
      }

      this.callApiMetadataPatch(
        {
          subscription: plan.code
        },
        () => {
          this.$auth.refreshTokens()
          this.initUserMetaData(this.$auth.user).then(() => {
            this.showSuccess('Your subscription has been updated')
            this.$store.dispatch('settings/reset')
            setTimeout(() => {
              if (this.creatingNewSubscription) {
                // new users should be redirected back to the home page after signup
                this.$router.push('/')
              } else {
                this.$router.push('/settings')
              }
            }, 2000)
          })
        }
      )
    },
    async addCard() {
      const { error } = await this.stripe.confirmCardSetup(
        this.intent.client_secret,
        {
          payment_method: {
            card: this.cardNumberElement,
            billing_details: {
              name: this.form.cardHolderName,
              email: this.form.email
            }
          }
        }
      )

      if (error) {
        return Promise.reject(error)
      }

      return Promise.resolve()
    }
  }
}
